export default "__VITE_ASSET__566f0f09__"